import { Role } from 'api/roles'

export const ADMIN_ROLE_NAME = 'admin'

export type BadgeVariant = 'standard' | 'template'

export const isAdminRole = (role: Role) =>
  role.preset && role.name === ADMIN_ROLE_NAME

// TODO: update if we ever need to add more standard, assignable roles, currently only admin.
export const isStandardRole = isAdminRole

export const isTemplateRole = (role: Role) =>
  role.preset && role.name !== ADMIN_ROLE_NAME

export const isAssignableRole = (role: Role) =>
  !role.preset || role.name === ADMIN_ROLE_NAME

export const getRoleBadgeVariant = (role: Role): BadgeVariant | null => {
  if (isStandardRole(role)) return 'standard'
  if (isTemplateRole(role)) return 'template'
  return null
}
